"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _QuestionEntityRecord = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/QuestionEntityRecord"));

var _Constants = require("composer-plugins/plugins/questionAndAnswer/Constants");

var _UITextArea = _interopRequireDefault(require("UIComponents/input/UITextArea"));

var NoteContent = function NoteContent(_ref) {
  var question = _ref.question,
      onSubmissionChanged = _ref.onSubmissionChanged,
      disabled = _ref.disabled;

  if (!question || !question.includeNotes) {
    return null;
  }

  return _react.default.createElement(_UITextArea.default, {
    value: question.note,
    placeholder: _I18n.default.text('composer-plugins.questionAndAnswer.notes'),
    maxLength: _Constants.MAX_NOTE_LENGTH,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return onSubmissionChanged(question.set('note', value));
    },
    disabled: disabled,
    resize: disabled ? false : 'vertical',
    "data-selenium-test": "q-and-a-notes"
  });
};

NoteContent.propTypes = {
  question: _propTypes.default.instanceOf(_QuestionEntityRecord.default),
  onSubmissionChanged: _propTypes.default.func,
  disabled: _propTypes.default.bool
};
var _default = NoteContent;
exports.default = _default;
module.exports = exports.default;